// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ─── SubTableView Custom Styles ─── */

.subtable-wrapper .p-datatable-thead > tr > th {
  background: #f8fafc !important;
  color: #475569 !important;
  font-weight: 600 !important;
  font-size: 12px !important;
  text-transform: uppercase !important;
  letter-spacing: 0.3px !important;
  border-bottom: 2px solid #e2e8f0 !important;
  text-align: center !important;
  justify-content: center !important;
}

.subtable-wrapper .p-datatable-thead > tr > th .p-column-header-content {
  justify-content: center !important;
}

.subtable-wrapper .p-datatable-thead > tr > th .p-sortable-column-icon {
  font-size: 7px !important;
}

.subtable-wrapper .p-datatable-tbody > tr {
  transition: background 0.15s ease;
}

.subtable-wrapper .p-datatable-tbody > tr > td {
  text-align: center !important;
  vertical-align: middle !important;
}

.subtable-wrapper .p-datatable-tbody > tr:hover {
  background: #f1f5f9 !important;
}

.subtable-wrapper .p-datatable-tbody > tr > td {
  padding: 6px 8px !important;
  font-size: 13px !important;
}

.subtable-wrapper .p-paginator {
  background: transparent !important;
  border-top: 1px solid #e8edf5 !important;
  padding-top: 12px !important;
}

.subtable-wrapper .p-paginator .p-paginator-page,
.subtable-wrapper .p-paginator .p-paginator-pages .p-paginator-page {
  min-width: 2rem;
  height: 2rem;
  font-size: 12px;
}

.subtable-wrapper .p-paginator .p-paginator-current {
  font-size: 12px;
  color: #64748b;
}

/* ── Toolbar button group ── */
.subtable-toolbar-btn {
  background: rgba(255,255,255,0.12) !important;
  border: 1px solid rgba(255,255,255,0.45) !important;
  color: #ffffff !important;
  border-radius: 8px !important;
  padding: 6px 14px !important;
  font-weight: 500 !important;
  font-size: 13px !important;
  backdrop-filter: blur(4px) !important;
  transition: all 0.2s ease !important;
  box-shadow: none !important;
}

.subtable-toolbar-btn:hover {
  background: rgba(255,255,255,0.22) !important;
  border-color: rgba(255,255,255,0.7) !important;
  box-shadow: 0 2px 12px rgba(255,255,255,0.15) !important;
}

.subtable-toolbar-btn:active {
  background: rgba(255,255,255,0.28) !important;
}

/* ── Structure thumbnail hover ── */
.subtable-structure-thumb:hover {
  border-color: #3b82f6 !important;
  box-shadow: 0 2px 8px rgba(59,130,246,0.15), 0 0 0 2px rgba(59,130,246,0.1) !important;
}

/* ── ID column emphasis ── */
.subtable-id-cell {
  color: #4f46e5 !important;
  font-weight: 600 !important;
  font-size: 13px !important;
}

/* ── Empty state ── */
.subtable-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px 16px;
  color: #94a3b8;
}

.subtable-empty-state i {
  font-size: 2.5rem;
  margin-bottom: 12px;
  opacity: 0.5;
}

.subtable-empty-state span {
  font-size: 14px;
}

/* ── Dialog footer gradient button ── */
.subtable-primary-btn {
  background: linear-gradient(135deg, #6366f1, #4f46e5) !important;
  border: none !important;
  color: #fff !important;
  border-radius: 6px !important;
  padding: 8px 16px !important;
  font-weight: 500 !important;
  box-shadow: 0 2px 6px rgba(99,102,241,0.25) !important;
  transition: all 0.2s ease !important;
}

.subtable-primary-btn:hover {
  box-shadow: 0 4px 12px rgba(99,102,241,0.35) !important;
  transform: translateY(-1px);
}

.subtable-primary-btn:active {
  transform: translateY(0);
  box-shadow: 0 1px 3px rgba(99,102,241,0.2) !important;
}

/* ── Inline edit input ── */
.subtable-inline-input input {
  font-size: 12px !important;
  padding: 2px 6px !important;
}

/* ── Actions column ── */
.subtable-wrapper .subtable-actions {
  justify-content: center !important;
  align-items: center !important;
}

/* ── Row resize handle ── */
.subtable-row-resize-handle {
  position: absolute;
  bottom: -3px;
  left: 0;
  right: 0;
  height: 6px;
  background: transparent;
  cursor: ns-resize;
  z-index: 5;
}

.subtable-row-resize-handle::after {
  content: '';
  position: absolute;
  left: 25%;
  right: 25%;
  top: 2px;
  height: 2px;
  background: transparent;
  border-radius: 2px;
  transition: background 0.15s;
}

.subtable-row-resize-handle:hover::after {
  background: #6366f1;
}

.subtable-row-resize-handle:active::after {
  background: #4f46e5;
  height: 3px;
}
`, "",{"version":3,"sources":["webpack://./src/scene-pm/Projects/ProjectView/SubTableView/SubTableView.css"],"names":[],"mappings":"AAAA,uCAAuC;;AAEvC;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,2BAA2B;EAC3B,0BAA0B;EAC1B,oCAAoC;EACpC,gCAAgC;EAChC,2CAA2C;EAC3C,6BAA6B;EAC7B,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,6BAA6B;EAC7B,iCAAiC;AACnC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;EACxC,4BAA4B;AAC9B;;AAEA;;EAEE,eAAe;EACf,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,+BAA+B;AAC/B;EACE,6CAA6C;EAC7C,mDAAmD;EACnD,yBAAyB;EACzB,6BAA6B;EAC7B,4BAA4B;EAC5B,2BAA2B;EAC3B,0BAA0B;EAC1B,qCAAqC;EACrC,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,6CAA6C;EAC7C,8CAA8C;EAC9C,wDAAwD;AAC1D;;AAEA;EACE,6CAA6C;AAC/C;;AAEA,oCAAoC;AACpC;EACE,gCAAgC;EAChC,sFAAsF;AACxF;;AAEA,6BAA6B;AAC7B;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA,wCAAwC;AACxC;EACE,gEAAgE;EAChE,uBAAuB;EACvB,sBAAsB;EACtB,6BAA6B;EAC7B,4BAA4B;EAC5B,2BAA2B;EAC3B,sDAAsD;EACtD,oCAAoC;AACtC;;AAEA;EACE,uDAAuD;EACvD,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,qDAAqD;AACvD;;AAEA,4BAA4B;AAC5B;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA,yBAAyB;AACzB;EACE,kCAAkC;EAClC,8BAA8B;AAChC;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,WAAW;EACX,uBAAuB;EACvB,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,QAAQ;EACR,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb","sourcesContent":["/* ─── SubTableView Custom Styles ─── */\n\n.subtable-wrapper .p-datatable-thead > tr > th {\n  background: #f8fafc !important;\n  color: #475569 !important;\n  font-weight: 600 !important;\n  font-size: 12px !important;\n  text-transform: uppercase !important;\n  letter-spacing: 0.3px !important;\n  border-bottom: 2px solid #e2e8f0 !important;\n  text-align: center !important;\n  justify-content: center !important;\n}\n\n.subtable-wrapper .p-datatable-thead > tr > th .p-column-header-content {\n  justify-content: center !important;\n}\n\n.subtable-wrapper .p-datatable-thead > tr > th .p-sortable-column-icon {\n  font-size: 7px !important;\n}\n\n.subtable-wrapper .p-datatable-tbody > tr {\n  transition: background 0.15s ease;\n}\n\n.subtable-wrapper .p-datatable-tbody > tr > td {\n  text-align: center !important;\n  vertical-align: middle !important;\n}\n\n.subtable-wrapper .p-datatable-tbody > tr:hover {\n  background: #f1f5f9 !important;\n}\n\n.subtable-wrapper .p-datatable-tbody > tr > td {\n  padding: 6px 8px !important;\n  font-size: 13px !important;\n}\n\n.subtable-wrapper .p-paginator {\n  background: transparent !important;\n  border-top: 1px solid #e8edf5 !important;\n  padding-top: 12px !important;\n}\n\n.subtable-wrapper .p-paginator .p-paginator-page,\n.subtable-wrapper .p-paginator .p-paginator-pages .p-paginator-page {\n  min-width: 2rem;\n  height: 2rem;\n  font-size: 12px;\n}\n\n.subtable-wrapper .p-paginator .p-paginator-current {\n  font-size: 12px;\n  color: #64748b;\n}\n\n/* ── Toolbar button group ── */\n.subtable-toolbar-btn {\n  background: rgba(255,255,255,0.12) !important;\n  border: 1px solid rgba(255,255,255,0.45) !important;\n  color: #ffffff !important;\n  border-radius: 8px !important;\n  padding: 6px 14px !important;\n  font-weight: 500 !important;\n  font-size: 13px !important;\n  backdrop-filter: blur(4px) !important;\n  transition: all 0.2s ease !important;\n  box-shadow: none !important;\n}\n\n.subtable-toolbar-btn:hover {\n  background: rgba(255,255,255,0.22) !important;\n  border-color: rgba(255,255,255,0.7) !important;\n  box-shadow: 0 2px 12px rgba(255,255,255,0.15) !important;\n}\n\n.subtable-toolbar-btn:active {\n  background: rgba(255,255,255,0.28) !important;\n}\n\n/* ── Structure thumbnail hover ── */\n.subtable-structure-thumb:hover {\n  border-color: #3b82f6 !important;\n  box-shadow: 0 2px 8px rgba(59,130,246,0.15), 0 0 0 2px rgba(59,130,246,0.1) !important;\n}\n\n/* ── ID column emphasis ── */\n.subtable-id-cell {\n  color: #4f46e5 !important;\n  font-weight: 600 !important;\n  font-size: 13px !important;\n}\n\n/* ── Empty state ── */\n.subtable-empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 32px 16px;\n  color: #94a3b8;\n}\n\n.subtable-empty-state i {\n  font-size: 2.5rem;\n  margin-bottom: 12px;\n  opacity: 0.5;\n}\n\n.subtable-empty-state span {\n  font-size: 14px;\n}\n\n/* ── Dialog footer gradient button ── */\n.subtable-primary-btn {\n  background: linear-gradient(135deg, #6366f1, #4f46e5) !important;\n  border: none !important;\n  color: #fff !important;\n  border-radius: 6px !important;\n  padding: 8px 16px !important;\n  font-weight: 500 !important;\n  box-shadow: 0 2px 6px rgba(99,102,241,0.25) !important;\n  transition: all 0.2s ease !important;\n}\n\n.subtable-primary-btn:hover {\n  box-shadow: 0 4px 12px rgba(99,102,241,0.35) !important;\n  transform: translateY(-1px);\n}\n\n.subtable-primary-btn:active {\n  transform: translateY(0);\n  box-shadow: 0 1px 3px rgba(99,102,241,0.2) !important;\n}\n\n/* ── Inline edit input ── */\n.subtable-inline-input input {\n  font-size: 12px !important;\n  padding: 2px 6px !important;\n}\n\n/* ── Actions column ── */\n.subtable-wrapper .subtable-actions {\n  justify-content: center !important;\n  align-items: center !important;\n}\n\n/* ── Row resize handle ── */\n.subtable-row-resize-handle {\n  position: absolute;\n  bottom: -3px;\n  left: 0;\n  right: 0;\n  height: 6px;\n  background: transparent;\n  cursor: ns-resize;\n  z-index: 5;\n}\n\n.subtable-row-resize-handle::after {\n  content: '';\n  position: absolute;\n  left: 25%;\n  right: 25%;\n  top: 2px;\n  height: 2px;\n  background: transparent;\n  border-radius: 2px;\n  transition: background 0.15s;\n}\n\n.subtable-row-resize-handle:hover::after {\n  background: #6366f1;\n}\n\n.subtable-row-resize-handle:active::after {\n  background: #4f46e5;\n  height: 3px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
